import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';
import SelectBox from '../components/SelectBox';
import Button from '../audi-ui-components/Button';
import { Formik, Form } from 'formik';
import Spinner from '../audi-ui-components/Spinner';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _countBy from 'lodash/countBy';
import cookie from '../lib/cookie';

const mapStateToProps = (state) => {
    return {
        cart: state.shoppingCart.cart,
        disableNav: state.shoppingCart.disableNav,
    };
};

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        fetchData: ACTIONS_CREATOR.fetchData,
        setShoppingCart: ACTIONS_CREATOR.setShoppingCart,
        disableNavItems: ACTIONS_CREATOR.disableNavItems,
        setAlertMessage: ACTIONS_CREATOR.setAlertMessage,
        setHero: ACTIONS_CREATOR.setHero
    },
    dispatch,
);

class ExperiencePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingPrograms: true,
            availableDates: null,
            selectedVenueId: null,
            selectedProgramId: null,
            selectedExperienceId: null,
            programDetails: null,
            venues: null
        };
    }

    componentDidMount() {
        this.fetchPrograms();
    }

    componentWillUnmount() {
        this.props.setHero();
    }

    fetchPrograms = () => {
        this.setState({fetchingPrograms: true});
        this.props.setAlertMessage(true, 'success', 'Fetching Program details...');
        this.props.fetchData(`/1/programs/`, 'GET')
        .then(programs => {
            let myProgram;
            if (this.props.programSlug) {
                myProgram = programs.filter((p) => {
                    return p.slug === this.props.programSlug;
                });
            } else {
                myProgram = programs;
            }
            if (myProgram.length > 0) {
                this.props.setAlertMessage(false);
                this.props.setHero(myProgram[0].name, myProgram[0].heroImage, myProgram[0].mobileHeroImage);
                this.setState({
                    programDetails: myProgram[0],
                    selectedProgramId: myProgram[0].id
                });
                this.fetchVenues(myProgram[0].id);
            } else {
                this.props.setAlertMessage(true, 'danger', CONST.ERR_MSG_NO_COURSES);
            }
            this.setState({fetchingPrograms: false});
        })
        .catch(err => {
            console.log(err);
            err.then(errorMessage => {
                this.props.setAlertMessage(true, 'danger', errorMessage.message);
            });
            this.setState({fetchingPrograms: false});
        });
    }

    fetchVenues = (programId) => {
        this.setState({fetchingPrograms: true});
        this.props.setAlertMessage(true, 'success', 'Fetching Venues...');
        this.props.fetchData(`/1/programs/${programId}/venues`, 'GET')
        .then(venues => {
            if (venues.length === 0) {
                this.setState({fetchingPrograms: false});
                this.props.setAlertMessage(true, 'danger', CONST.ERR_MSG_NO_LOCATIONS);
                return;
            }
            var selectedVenue = venues[0];
            if (this.props.locationSlug) {
                selectedVenue = _find(venues, {slug: this.props.locationSlug});
            }
            this.setState({
                fetchingPrograms: false,
                venues: venues,
                selectedVenueId: selectedVenue.id
            });
            this.props.setAlertMessage(false);
            let experiences;
            if (selectedVenue) {
                experiences = selectedVenue.experiences;
                var expId = experiences[0].id;
                if (this.props.experienceId) {
                    var expIdx = _findIndex(experiences, {id: parseInt(this.props.experienceId)});
                    if (expIdx > -1) {
                        expId = experiences[expIdx].id;
                    }
                }
                this.setState({availableDates: experiences, selectedExperienceId: expId});
            } else {
                this.props.setAlertMessage(true, 'danger', CONST.ERR_MSG_NO_LOCATIONS);
            }
        })
        .catch(err => {
            console.log(err)
            err.then(errorMessage => {
                this.props.setAlertMessage(true, 'danger', errorMessage.message);
            });
            this.setState({fetchingPrograms: false});
        });
        this.props.disableNavItems(this.props.disableNav, CONST.SHOPPING_NAV_INDEX, false);
    }

    fetchExperiences = (v) => {
        const venueId = parseInt(v, 10);
        const availableDates = _find(this.state.venues, {id: venueId});
        this.setState({
            selectedVenueId: v,
            selectedExperienceId: availableDates.experiences[0].id,
            availableDates: availableDates.experiences,
            fetchingPrograms: false
        });
    }

    get currentExperience() {
        const {availableDates, selectedExperienceId} = this.state;
        const experience = this.state.availableDates ? _find(availableDates, function(o) { return o.id.toString() === selectedExperienceId.toString(); }) : null;
        return experience;
    }

    addItemToCart = (experience) => {
        const {cart} = this.props;
        if (cart.items.length) {
            var count = _countBy(cart.items, function (o) { return o.experience && o.experience.id === experience.id; });
            var numInCart = parseInt(count.true) || 0;
            if ((experience.totalSeats - experience.bookedSeats - numInCart) < 1) {
                this.props.setAlertMessage(true, 'danger', "Sorry, there are not enough spots left.");
                return;
            }
        }
        this.props.setAlertMessage(true, 'success', 'Adding to cart...');
        const url = `/1/cart/${this.props.cart.id}/item`;
        const body = {
            type: CONST.ITEM_EXPERIENCE,
            programId: this.state.selectedProgramId,
            experienceId: experience.id,
            amount: this.state.programDetails.cost,
        };
        this.props.fetchData(url, 'POST', body)
            .then(result => {
                this.props.setShoppingCart(result);
                cookie.setItem("cartId", `${result.id}`, null, '/');
                this.props.setAlertMessage(false);
            })
            .catch(err => {
                err.then( errorMessage => {
                    this.props.setAlertMessage(true, 'danger', errorMessage.message);
                });
            });
    }

    render() {
        const {programDetails, venues, availableDates} = this.state;
        var spotsLeft = false;
        let exp = this.currentExperience;
        if (exp && exp !== null) {
            spotsLeft = exp.totalSeats - exp.bookedSeats;
        }
        return (
            <section className="product-page mb-5">
                {programDetails && programDetails.description && <div className="mb-5">
                    <p className="aui-headline-5">Experience details</p>
                    <div dangerouslySetInnerHTML={{__html: programDetails.description}}></div>
                </div>}
                <Formik
                    enableReinitialize
                    initialValues={{
                        location: this.state.selectedVenueId || "",
                        dateTime: this.state.selectedExperienceId || "",
                    }}
                    onSubmit={(values, actions) => {
                        this.addItemToCart(this.currentExperience);
                    }}
                >
                    {({values, setFieldValue}) => (<Form id="experienceForm">
                        <div className="row">
                            <div className="col">
                                <div className="row mb-4">
                                    <div className="col-auto">
                                        <div className="product-label aui-headline-5">Your Circuit</div>
                                    </div>
                                    <div className="col">
                                        <SelectBox name="location"
                                            value={values.location}
                                            onChange= {(v) => { setFieldValue('location', v); this.fetchExperiences(v);}}
                                            options={venues ? venues.map((item) => { return {value: item.id, label: item.location}; }) : []}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-auto">
                                        <div className="product-label aui-headline-5">Date + Time</div>
                                    </div>
                                    <div className="col">
                                        <SelectBox name="dateTime"
                                            value={values.dateTime}
                                            disabled = {this.state.fetchingPrograms}
                                            onChange= {(v) => { setFieldValue('dateTime', v); this.setState({selectedExperienceId: v}); }}
                                            options={availableDates ? availableDates.map(experience => {
                                                    const startDate = new Date(experience.startDate);
                                                    const dateFormat = new Intl.DateTimeFormat('en-GB', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
                                                    if (experience.startDate !== experience.endDate) {
                                                      let endDate = new Date(experience.endDate);
                                                      return {
                                                          label: `${ dateFormat.format(startDate) } - ${dateFormat.format(endDate)}`,
                                                          value: experience.id,
                                                      };
                                                    }
                                                    return {
                                                        label: `${ dateFormat.format(startDate) }, ${experience.startTime} - ${experience.endTime}`,
                                                        value: experience.id,
                                                    };
                                                }) : []}
                                        />
                                    </div>
                                </div>

                                {this.state.fetching &&  <div className="spots-left"><Spinner isContinuous small /></div>}
                                {!this.state.fetching && <div className="spots-left">
                                    {spotsLeft > 5 && <strong>Limited spots available</strong>}
                                    {spotsLeft < 5 && spotsLeft > 0 && <strong>{spotsLeft} Spots left</strong>}
                                    {spotsLeft === 0 && <strong className="aui-color-text-red">0 Spots left</strong>}
                                </div>}

                            </div>
                            <div className="col-auto d-none d-medium-block"><div className="product-page--divider"></div></div>
                            <div className="col-12 col-medium-4 total-cost">
                                <div className="row">
                                    <div className="col-auto col-medium-12">
                                        <div className="aui-headline-5 py-2 pt-medium-0 px-2">TOTAL COST</div>
                                    </div>
                                    <div className="col-auto col-medium-12">
                                        {programDetails && <div className="aui-headline-5 grey-background py-2 px-3 mb-3">AUD$ <span style={{fontWeight: 'normal'}}>{programDetails.cost}</span></div>}
                                    </div>
                                </div>
                                <div style={{textAlign: 'right'}}><Button variant="primary" className="ms-auto" type="submit" disabled={!spotsLeft || spotsLeft === 0}>Add to cart</Button></div>
                            </div>
                       </div>
                    </Form>)}
                </Formik>
            </section>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExperiencePage);
